import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import { __DEV__ } from '../../utils/assertion.esm.js';
import '../../utils/ssr.esm.js';
import '../../utils/number.esm.js';
import '../../utils/array.esm.js';
import '../../utils/breakpoint.esm.js';
import '../../utils/context.esm.js';
import '../../utils/dom.esm.js';
import '../../utils/tabbable.esm.js';
import '../../utils/dom-query.esm.js';
import '../../utils/logger.esm.js';
import '../../utils/focus.esm.js';
import '../../utils/function.esm.js';
import '../../utils/keydown.esm.js';
import '../../utils/lazy.esm.js';
import '../../utils/object.esm.js';
import '../../utils/react-helpers.esm.js';
import '../../utils/style-props.esm.js';
import '../../utils/tailwind.esm.js';
import Box from '../Box/index.esm.js';
import { iconList, icons } from './icons.esm.js';
export { iconList } from './icons.esm.js';
import { iconSizes } from './types.esm.js';

var Icon = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  var color = props.color,
      _props$focusable = props.focusable,
      focusable = _props$focusable === void 0 ? false : _props$focusable,
      name = props.name,
      _props$role = props.role,
      role = _props$role === void 0 ? 'presentation' : _props$role,
      size = props.size,
      _props$display = props.display,
      display = _props$display === void 0 ? 'inline-block' : _props$display,
      _props$fill = props.fill,
      fill = _props$fill === void 0 ? 'fill-current' : _props$fill,
      rest = _objectWithoutPropertiesLoose(props, ["color", "focusable", "name", "role", "size", "display", "fill"]);

  var height = props.height,
      width = props.width;

  if (!iconList.includes(name)) {
    return null;
  }

  var _icons$name = icons[name],
      html = _icons$name.html,
      info = _icons$name.info;
  var viewBox = info.viewBox;
  var htmlWidth = info.width,
      htmlHeight = info.height;
  var styleProps = {
    display: display,
    fill: fill
  };

  if (display === 'inline-block') {
    styleProps.verticalAlign = 'align-middle';
  }

  if (color) {
    styleProps.textColor = color;
  }

  if (size) {
    var _iconSizes$size = iconSizes[size];
    width = _iconSizes$size[0];
    height = _iconSizes$size[1];
  }

  return React__default.createElement(Box, _extends({
    ref: ref,
    as: "svg",
    htmlHeight: !height ? htmlHeight : undefined,
    htmlWidth: !width ? htmlWidth : undefined,
    height: height,
    width: width,
    viewBox: viewBox,
    // @ts-ignore
    focusable: focusable,
    role: role,
    dangerouslySetInnerHTML: {
      __html: html
    }
  }, styleProps, rest));
});

if (__DEV__) {
  Icon.displayName = 'Icon';
}

export default Icon;
//# sourceMappingURL=index.esm.js.map
